// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/stats.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.stats";

/** A single aggregated bucket in the history heatmap. */
export interface HistoryHeatmapBucket {
  /** Start of the time bucket (day or week start) */
  bucketDate:
    | Date
    | undefined;
  /** Actor user ID (empty if not actor-scoped) */
  actorId: string;
  /** Project / area ID (empty if not area-scoped) */
  projectId: string;
  /** Number of changes in this bucket */
  count: number;
}

/** Aggregated heatmap data for the history view. */
export interface HistoryHeatmapData {
  /** Buckets aggregated by feature area (count per area, sub-labels for actors) */
  featureAreaBuckets: HistoryHeatmapBucket[];
  /** Buckets aggregated by team member (count per actor, sub-labels for areas) */
  teamMemberBuckets: HistoryHeatmapBucket[];
  /** personId → display name */
  actorNames: { [key: string]: string };
  /** area title → area title (for areas with activity) */
  projectNames: { [key: string]: string };
  /** Ordered area titles from ProductCatalogue */
  areaOrder: string[];
}

export interface HistoryHeatmapData_ActorNamesEntry {
  key: string;
  value: string;
}

export interface HistoryHeatmapData_ProjectNamesEntry {
  key: string;
  value: string;
}

function createBaseHistoryHeatmapBucket(): HistoryHeatmapBucket {
  return { bucketDate: undefined, actorId: "", projectId: "", count: 0 };
}

export const HistoryHeatmapBucket: MessageFns<HistoryHeatmapBucket> = {
  encode(message: HistoryHeatmapBucket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bucketDate !== undefined) {
      Timestamp.encode(toTimestamp(message.bucketDate), writer.uint32(10).fork()).join();
    }
    if (message.actorId !== "") {
      writer.uint32(18).string(message.actorId);
    }
    if (message.projectId !== "") {
      writer.uint32(26).string(message.projectId);
    }
    if (message.count !== 0) {
      writer.uint32(32).int32(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryHeatmapBucket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryHeatmapBucket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bucketDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.actorId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.count = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryHeatmapBucket {
    return {
      bucketDate: isSet(object.bucketDate)
        ? fromJsonTimestamp(object.bucketDate)
        : isSet(object.bucket_date)
        ? fromJsonTimestamp(object.bucket_date)
        : undefined,
      actorId: isSet(object.actorId)
        ? globalThis.String(object.actorId)
        : isSet(object.actor_id)
        ? globalThis.String(object.actor_id)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
    };
  },

  toJSON(message: HistoryHeatmapBucket): unknown {
    const obj: any = {};
    if (message.bucketDate !== undefined) {
      obj.bucketDate = message.bucketDate.toISOString();
    }
    if (message.actorId !== "") {
      obj.actorId = message.actorId;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create(base?: DeepPartial<HistoryHeatmapBucket>): HistoryHeatmapBucket {
    return HistoryHeatmapBucket.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HistoryHeatmapBucket>): HistoryHeatmapBucket {
    const message = createBaseHistoryHeatmapBucket();
    message.bucketDate = object.bucketDate ?? undefined;
    message.actorId = object.actorId ?? "";
    message.projectId = object.projectId ?? "";
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseHistoryHeatmapData(): HistoryHeatmapData {
  return { featureAreaBuckets: [], teamMemberBuckets: [], actorNames: {}, projectNames: {}, areaOrder: [] };
}

export const HistoryHeatmapData: MessageFns<HistoryHeatmapData> = {
  encode(message: HistoryHeatmapData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.featureAreaBuckets) {
      HistoryHeatmapBucket.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.teamMemberBuckets) {
      HistoryHeatmapBucket.encode(v!, writer.uint32(18).fork()).join();
    }
    globalThis.Object.entries(message.actorNames).forEach(([key, value]: [string, string]) => {
      HistoryHeatmapData_ActorNamesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.projectNames).forEach(([key, value]: [string, string]) => {
      HistoryHeatmapData_ProjectNamesEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    for (const v of message.areaOrder) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryHeatmapData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryHeatmapData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureAreaBuckets.push(HistoryHeatmapBucket.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teamMemberBuckets.push(HistoryHeatmapBucket.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = HistoryHeatmapData_ActorNamesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.actorNames[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = HistoryHeatmapData_ProjectNamesEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.projectNames[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.areaOrder.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryHeatmapData {
    return {
      featureAreaBuckets: globalThis.Array.isArray(object?.featureAreaBuckets)
        ? object.featureAreaBuckets.map((e: any) => HistoryHeatmapBucket.fromJSON(e))
        : globalThis.Array.isArray(object?.feature_area_buckets)
        ? object.feature_area_buckets.map((e: any) => HistoryHeatmapBucket.fromJSON(e))
        : [],
      teamMemberBuckets: globalThis.Array.isArray(object?.teamMemberBuckets)
        ? object.teamMemberBuckets.map((e: any) => HistoryHeatmapBucket.fromJSON(e))
        : globalThis.Array.isArray(object?.team_member_buckets)
        ? object.team_member_buckets.map((e: any) => HistoryHeatmapBucket.fromJSON(e))
        : [],
      actorNames: isObject(object.actorNames)
        ? (globalThis.Object.entries(object.actorNames) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.actor_names)
        ? (globalThis.Object.entries(object.actor_names) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
      projectNames: isObject(object.projectNames)
        ? (globalThis.Object.entries(object.projectNames) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.project_names)
        ? (globalThis.Object.entries(object.project_names) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
      areaOrder: globalThis.Array.isArray(object?.areaOrder)
        ? object.areaOrder.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.area_order)
        ? object.area_order.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: HistoryHeatmapData): unknown {
    const obj: any = {};
    if (message.featureAreaBuckets?.length) {
      obj.featureAreaBuckets = message.featureAreaBuckets.map((e) => HistoryHeatmapBucket.toJSON(e));
    }
    if (message.teamMemberBuckets?.length) {
      obj.teamMemberBuckets = message.teamMemberBuckets.map((e) => HistoryHeatmapBucket.toJSON(e));
    }
    if (message.actorNames) {
      const entries = globalThis.Object.entries(message.actorNames) as [string, string][];
      if (entries.length > 0) {
        obj.actorNames = {};
        entries.forEach(([k, v]) => {
          obj.actorNames[k] = v;
        });
      }
    }
    if (message.projectNames) {
      const entries = globalThis.Object.entries(message.projectNames) as [string, string][];
      if (entries.length > 0) {
        obj.projectNames = {};
        entries.forEach(([k, v]) => {
          obj.projectNames[k] = v;
        });
      }
    }
    if (message.areaOrder?.length) {
      obj.areaOrder = message.areaOrder;
    }
    return obj;
  },

  create(base?: DeepPartial<HistoryHeatmapData>): HistoryHeatmapData {
    return HistoryHeatmapData.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HistoryHeatmapData>): HistoryHeatmapData {
    const message = createBaseHistoryHeatmapData();
    message.featureAreaBuckets = object.featureAreaBuckets?.map((e) => HistoryHeatmapBucket.fromPartial(e)) || [];
    message.teamMemberBuckets = object.teamMemberBuckets?.map((e) => HistoryHeatmapBucket.fromPartial(e)) || [];
    message.actorNames = (globalThis.Object.entries(object.actorNames ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.projectNames = (globalThis.Object.entries(object.projectNames ?? {}) as [string, string][]).reduce(
      (acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.areaOrder = object.areaOrder?.map((e) => e) || [];
    return message;
  },
};

function createBaseHistoryHeatmapData_ActorNamesEntry(): HistoryHeatmapData_ActorNamesEntry {
  return { key: "", value: "" };
}

export const HistoryHeatmapData_ActorNamesEntry: MessageFns<HistoryHeatmapData_ActorNamesEntry> = {
  encode(message: HistoryHeatmapData_ActorNamesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryHeatmapData_ActorNamesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryHeatmapData_ActorNamesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryHeatmapData_ActorNamesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: HistoryHeatmapData_ActorNamesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<HistoryHeatmapData_ActorNamesEntry>): HistoryHeatmapData_ActorNamesEntry {
    return HistoryHeatmapData_ActorNamesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HistoryHeatmapData_ActorNamesEntry>): HistoryHeatmapData_ActorNamesEntry {
    const message = createBaseHistoryHeatmapData_ActorNamesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseHistoryHeatmapData_ProjectNamesEntry(): HistoryHeatmapData_ProjectNamesEntry {
  return { key: "", value: "" };
}

export const HistoryHeatmapData_ProjectNamesEntry: MessageFns<HistoryHeatmapData_ProjectNamesEntry> = {
  encode(message: HistoryHeatmapData_ProjectNamesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryHeatmapData_ProjectNamesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryHeatmapData_ProjectNamesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryHeatmapData_ProjectNamesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: HistoryHeatmapData_ProjectNamesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<HistoryHeatmapData_ProjectNamesEntry>): HistoryHeatmapData_ProjectNamesEntry {
    return HistoryHeatmapData_ProjectNamesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HistoryHeatmapData_ProjectNamesEntry>): HistoryHeatmapData_ProjectNamesEntry {
    const message = createBaseHistoryHeatmapData_ProjectNamesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
